import gsap from 'gsap';

export default class NewsEvents {
  constructor() {
    this.news_events__remaining = document.querySelector('.news-events__remaining');
    this.limitNews = 8;

    if (this.news_events__remaining) {
      this.news_container = this.news_events__remaining.querySelector('.news-events__remaining__news');
      this.newsItems = this.news_container.querySelectorAll('.c-card-post');
      console.log('Found news-items:', this.newsItems);

      this.displayFirstFiveItems();
      this.initNewsItems();
      this.observeNewsItems();
    }
  }

  displayFirstFiveItems() {
    this.newsItems.forEach((item, index) => {
      if (index < this.limitNews) {
        gsap.set(item, {
          opacity: 1,
          xPercent: 0
        });
      }
    });
  }

  initNewsItems() {
    this.newsItems.forEach((item, index) => {
      if (index >= this.limitNews) {
        gsap.set(item, {
          xPercent: -125,
          opacity: 0
        });
      }
    });
  }

  observeNewsItems() {
    this.newsItems.forEach((item) => {

      gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: 'top 90%',
          once: true
        }
      })
      .to(item, {
        xPercent: 0,
        opacity: 1,
        duration: 1,
        ease: 'power3.out'
      });
    });
  }
}
